import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { TlkModalWindowModule, TlkModalWindowRef, TLK_MODAL_WINDOW_DATA } from '@itero/ui-toolkit-angular/modal-window';
import { TlkRadioButtonComponent, TlkRadioGroupDirective } from '@itero/ui-toolkit-angular/radio-button';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';

import { SaveContinueScannerIconComponent } from '@shared/components/save-continue-icons/save-continue-scanner-icon.component';
import { SaveContinueLabBrokerIconComponent } from '@shared/components/save-continue-icons/save-continue-lab-broker-icon.component';

export interface SaveAndContinueLaterDialogData {
	name: string;
}

type SaveAndContinueLaterSelection = 'continueOnScanner' | 'completeOnDentira';

export type SaveAndContinueLaterResult = boolean | null;

@Component({
	selector: 'rx-save-and-continue-later-dialog',
	templateUrl: './save-and-continue-later-dialog.component.html',
	styleUrls: ['./save-and-continue-later-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		FormsModule,
		TranslateModule,
		TlkModalWindowModule,
		TlkButtonComponent,
		TlkRadioButtonComponent,
		TlkRadioGroupDirective,
		SaveContinueScannerIconComponent,
		SaveContinueLabBrokerIconComponent
	]
})
export class SaveAndContinueLaterDialogComponent extends BaseDestroyableComponent {
	selectedOption: SaveAndContinueLaterSelection | null = null;

	constructor(
		public readonly dialogRef: TlkModalWindowRef<SaveAndContinueLaterResult, SaveAndContinueLaterDialogComponent>,
		@Inject(TLK_MODAL_WINDOW_DATA) public readonly data: SaveAndContinueLaterDialogData
	) {
		super();
	}

	get isConfirmDisabled(): boolean {
		return this.selectedOption === null;
	}

	selectContinueOnScanner(): void {
		this.selectedOption = 'continueOnScanner';
	}

	selectCompleteOnDentira(): void {
		this.selectedOption = 'completeOnDentira';
	}

	cancel(): void {
		this.dialogRef.close(null);
	}

	confirm(): void {
		if (this.selectedOption === null) {
			return;
		}

		this.dialogRef.close(this.selectedOption === 'completeOnDentira');
	}
}
